import { NoticeExtractorService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall, TCallOptions } from 'app/queries/types/TCall';
import type { noticeExtractorKeys } from './noticeExtractorKeys';

type TParams = QueryFunctionContext<ReturnType<typeof noticeExtractorKeys.workflowStatus>>;

export const createFetchNoticeExtractionStatusQueryFn =
  (call: TCall, options?: TCallOptions) =>
  ({ queryKey: [{ workflowId }], signal }: TParams) =>
    call(() => cancelOnSignal(NoticeExtractorService.getExtractionJobStatus({ jobId: workflowId }), signal), options);
